import React, { useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { ContentContainer, MainContentContainer } from 'common-ui/containers';
import { ActivityList } from 'common-ui/lists';
import { userApi } from 'core/lib';
import LoaderWrapper from 'utils/loader-wrapper';

import { UserDetailsContext } from '../../context';

const DealBaseActivityTab = () => {
  const user = useContext(UserDetailsContext);
  const { t } = useTranslation();
  const [getHistory, { data, isFetching }] = userApi.useLazyGetHistoryQuery();

  useEffect(() => {
    if (user?.id) {
      getHistory(user.id);
    }
  }, [user?.id, getHistory]);

  return (
    <MainContentContainer id="user-activity">
      <ContentContainer>
        <LoaderWrapper loading={isFetching} message={t('loaders:user.loadingActivity')}>
          <ActivityList data={data ?? []} />
        </LoaderWrapper>
      </ContentContainer>
    </MainContentContainer>
  );
};

export default DealBaseActivityTab;
